import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { Table } from "antd";
import AxiosInstance from "../../../AxiosInstance";
import { alertError } from "../../Helper/Alerts";
import RoleSwitch from "../../Helper/RoleSwitch";
import OtherPageHeader from "../../../components/OtherHeader";
import moment from "moment";
import { amountFormat } from "../../../utils";
import CompleteProfileModel from "../../../components/Model/CompleteProfileMode";
import InvestorPaymentModal from "../../../components/Model/InvestorPaymentModal";
import InvestorRedirectModal from "../../../components/Model/InvestorRedirectModal";
import AssignmentTrkRedirectModal from "../../../components/Model/AssignmentTrkRedirectModal";
import InvestmentChart from "../InvestorDashboard/investmentChart";
import { policyCenterRestricted } from "../InvestorDashboard/InvestorDashboard";

export default function InvestorMaturedPolicies() {
  const isBigScreen = useMediaQuery({ query: "(min-width: 1224px)" });
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 1000px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });
  const navigate = useNavigate();
  var [loading, setLoading] = useState(true);
  var [dataSource, setDataSource] = useState([]);
  var [userRoles, setUserRoles] = useState([]);
  var [userMeData, setUserMeData] = useState("");
  var [summaryData, setSummaryData] = useState([]);
  const [active, setActive] = useState(true);
  const [paginationMetaData, setPaginationMetaData] = useState({});
  const [inititatePaymentModal, setInititatePaymentModal] = useState(false);
  const [selectedPolicyForPayment, setPolicyForPayment] = useState({});
  const [isEmptyList, setIsEmptyList] = useState(false);

  useEffect(() => {
    getInvestorData(0);
    getUserMe();
    getSummary();
  }, []);
  const getSummary = () => {
    const url = "/investor/summary?isMatured=true";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        setSummaryData(resp.data);
      });
  };
  const getUserMe = () => {
    const url = "/user/me";
    AxiosInstance()
      .get(url)
      .then((resp) => {
        if (resp.status === 200) {
          //  setFirstName(resp.data.firstName);
          setUserMeData(resp.data);
          setUserRoles(resp.data.userRoles);
          const temp = resp.data.userRoles;
          if (temp.length > 1) {
            localStorage.setItem("user-type", "EXISTING");
          } else {
            localStorage.setItem("user-type", "NEW");
          }
          const result = temp.filter(function (letter) {
            return letter !== resp.data.currentRole;
          });
          localStorage.setItem("roles", result);
          localStorage.setItem(
            "username",
            resp.data.firstName + " " + resp.data.lastName
          );
        }
      });
  };

  const getInvestorData = (skip) => {
    const url = `/investor/policyList?take=10&skip=${skip}&status=DONE&isMatured=true`;
    AxiosInstance()
      .get(url)
      .then((resp) => {
        let { data } = resp;
        if (data?.data?.length === 0) {
        }
        setDataSource(data.data);
        setPaginationMetaData(data.paginationMetaData);
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "Insurer",
      dataIndex: "insurerLogo",
      key: "insurerLogo",
      align: "center",
      render: (text, policy) => (
        <>
          <img
            className="insurer-logo"
            alt="insurerlogo"
            src={policy.insurer.logo}
          />
        </>
      ),
    },
    {
      title: "Policy Number",
      dataIndex: "policyNumber",
      key: "policyNumber",
      align: "right",
      // render: (text, policy) => amountFormat(text) ?? "N/A",
    },
    {
      title: "Investment Date",
      dataIndex: "investmentDate",
      key: "investmentDate",
      align: "right",
      render: (text, policy) =>
      policy.assignmentStartDate? moment(policy.assignmentStartDate).format("DD/MM/YYYY"): "N/A",
    },
    {
      title: "Investment Amount",
      dataIndex: "investmentAmount",
      key: "investmentAmount",
      align: "right",
      render: (text, policy) => amountFormat(text) ?? "N/A",
    },
    {
      title: "Maturity Amount",
      dataIndex: "refundAmount",
      key: "refundAmount",
      align: "right",
      render: (text, policy) => amountFormat(text) ?? "N/A",
    },
    {
      title: "Growth",
      dataIndex: "growthRatio",
      key: "growthRatio",
      align: "right",
      render: (text, policy) => (text ? parseInt(text) + " %" : "N/A"),
    },
    {
      title: "Liquidation Value (Tentative)",
      dataIndex: "liquidationAmount",
      key: "liquidationAmount",
      align: "right",
      render: (text, policy) => amountFormat(text) ?? "N/A",
    },
    {
      title: "Realized P&L",
      dataIndex: "unrealizedPAndL",
      key: "unrealizedPAndL",
      align: "right",
      render: (text, policy) => amountFormat(text) ?? "N/A",
    },
    {
      title: "Maturity Date",
      dataIndex: "refundDate",
      key: "refundDate",
      align: "right",
      render: (text, policy) =>policy.refundDate? moment(policy.refundDate).format("DD/MM/YYYY"): "N/A",
    },
    // {
    //   title: "Estimated Maturity Value",
    //   dataIndex: "maturityAmount",
    //   key: "maturityAmount",
    //   align: "right",
    //   render: (text, policy) => amountFormat(text) ?? "N/A",
    // },
    // {
    //   title: "Maturity Date",
    //   dataIndex: "maturityDate",
    //   key: "maturityDate",
    //   align: "center",
    //   render: (text, policy) =>
    //     moment(policy.maturityDate).format("DD/MM/YYYY"),
    // },
    // {
    //   title: "ROI",
    //   dataIndex: "roiPercentage",
    //   key: "roiPercentage",
    //   align: "center",
    //   render: (text, policy) =>
    //     text ? parseFloat(text).toFixed(1) + " %" : "N/A",
    // },
    // {
    //   title: "Assignment Status",
    //   dataIndex: "assignmentStatus",
    //   key: "assignmentStatus",
    //   align: "center",
    //   render: (text, policy) => {
    //     return (
    //       <>
    //         {assignmentStatusNames(policy?.assignments[0]?.status)}
    //         <br></br>
    //         {policy?.assignments &&
    //         policy?.assignments[0]?.status === "PAYMENT_PENDING" ? (
    //           <Link
    //             onClick={() => {
    //               setPolicyForPayment(policy);
    //               setInititatePaymentModal(true);
    //             }}
    //             // className="tableButton-in"
    //           >
    //             {"Make Payment"}
    //           </Link>
    //         ) : (
    //           ""
    //         )}
    //       </>
    //     );
    //   },
    // },
  ];
  const change = (data) => {
    getInvestorData((data - 1) * 10);
  };
  const assignmentStatusNames = (status) => {
    if (status === "PENDING") {
      return "Details Pending";
    } else if (status === "SENT") {
      return "Sent to Insurer";
    } else if (status === "APPROVED") {
      return "Request Approved";
    } else if (status === "REJECTED") {
      return "Request Declined";
    } else if (status === "PAYMENT_PENDING") {
      return "Payment Due";
    } else if (status === "PAYMENT_DONE") {
      return "Payment Done";
    } else if (status === "DONE") {
      return "Assigned";
    }
  };
  var SummaryComponent = () => {
    return (
      <>
        <div className="in-summary grid-container-in-summary">
          <div>
            <div className="heading-in">My Investments</div>
            <p>(Matured)</p>
          </div>
          <div>
            <div className="key">Total Investment</div>
            <div className="value">
              {summaryData.totalInvestmentValue
                ? amountFormat(summaryData.totalInvestmentValue)
                : "-"}
            </div>
            <div className="key mt-3">Total Maturiy Amount</div>
            <div className="value">
              {summaryData.refundAmount? amountFormat(summaryData.refundAmount): "-"}
            </div>
          </div>

          <div className="">
            {/* <div className="key">Liquidation Value(Tentative)</div>
            <div className="value">
              {summaryData.liquidationAmount
                ? amountFormat(summaryData.liquidationAmount)
                : "-"}
            </div> */}
            <div className="key mt-3">Realized P&L</div>
            <div className="value">
              {summaryData.totalUnrealizedPAndL
                ? amountFormat(summaryData.totalUnrealizedPAndL)
                : "-"}
            </div>
            {/* <div className="key mt-3">Tentative Maturity Value</div>
            <div className="value">
              {summaryData.tentativeMaturityValue
                ? amountFormat(summaryData.tentativeMaturityValue)
                : "-"}
            </div> */}
          </div>

          <div className="">
            <InvestmentChart summaryData={summaryData}></InvestmentChart>

            <div className="d-flex justify-content-center">
              Growth{" "}
              {summaryData.growthRatio ? summaryData.growthRatio + " %" : "-"}
            </div>
          </div>
        </div>
      </>
    );
  };
  var SummaryComponentMobile = () => {
    return (
      <>
        <div className="in-summary grid-container-in-summary">
          <div>
            <div className="heading-in">My Investments</div>
          </div>
          <div>
            <div className="key">Total Investment</div>
            <div className="value">
              {summaryData.totalInvestmentValue
                ? amountFormat(summaryData.totalInvestmentValue)
                : "-"}
            </div>
             <div className="key">Total Maturity Value</div>
            <div className="value">
              {summaryData.refundAmount? amountFormat(summaryData.refundAmount): "-"}
            </div>
          </div>

          <div className="">
            {/* <div className="key">Liquidation (Tentative)</div>
            <div className="value">
              {summaryData.liquidationAmount
                ? amountFormat(summaryData.liquidationAmount)
                : "-"}
            </div> */}
            <div className="key mt-3">Realized P&L</div>
            <div className="value">
              {summaryData.totalUnrealizedPAndL ?
                amountFormat(summaryData.totalUnrealizedPAndL)
                : "-"}
            </div>
            {/* <div className="key">Tentative Maturity Value</div>
            <div className="value">
              {summaryData.tentativeMaturityValue
                ? amountFormat(summaryData.tentativeMaturityValue)
                : "-"}
            </div> */}
          </div>

          {/* <div className="">
            <InvestmentChart  summaryData={summaryData}></InvestmentChart>

            <div className="d-flex justify-content-center">
              Growth{" "}
              {summaryData.growthRatio ? summaryData.growthRatio + " %" : "-"}
            </div>
          </div> */}
        </div>
      </>
    );
  };
  return (
    <section className="tre_bg-gray position-relative">
      <OtherPageHeader
        classProps="bg-transparent"
        innerClassProps="bg-transparent"
      />
      <InvestorPaymentModal
        policy={selectedPolicyForPayment}
        paymentModal={inititatePaymentModal}
        setPaymentModal={setInititatePaymentModal}
      ></InvestorPaymentModal>
      <AssignmentTrkRedirectModal
        active={isEmptyList}
        setActive={setIsEmptyList}
      ></AssignmentTrkRedirectModal>
      <div className="container bg-market">
        {/* <div className="topDiv-inDash">
        <img
          src="https://i.postimg.cc/ydRLNgzq/Logo-FV7-2.png"
          height={100}
          alt=""
        />
        {isTabletOrMobile ? null : <SummaryComponent />}

        <img
          src=" https://i.postimg.cc/TPfd0mC0/Vector.png"
          height={50}
          alt=""
        />
      </div> */}
        <div className="container">
          <div className="tre_top-summary tre_Summary overflow-hide  d-flex justify-content-center ">
            {isTabletOrMobile ? (
              <SummaryComponentMobile />
            ) : (
              <SummaryComponent />
            )}
          </div>
        </div>

        <div
          className="investMoreButton row  justify-content-between mx-0"
          // className="investMoreButton assignmentTrackerGap row gx-5 justify-content-between mx-0"
        >
          {" "}
          {!policyCenterRestricted.includes(userMeData?.phoneNumber) && (
            <div className="col p-0">
              <button
                className="go-portfolio "
                onClick={() => {
                  navigate("/policycenter");
                }}
              >
                <i class="fa-solid fa-plus tre_flex-hcenter text-white back-icon "></i>{" "}
                Invest More
              </button>
            </div>
          )}
          <div className="col p-0 d-flex justify-content-end">
            <button
              className="go-portfolio justify-content-end"
              onClick={() => {
                navigate("/investordashboard");
              }}
            >
              My Portfolio
              <i class="fa-solid fa-angle-right tre_flex-hcenter text-white back-icon mx-2 "></i>{" "}
            </button>
          </div>
        </div>

        <div className="policies-table">
          <Table
            bordered={true}
            scroll={{ x: 400 }}
            loading={loading}
            className="table"
            dataSource={[...dataSource]}
            columns={columns}
            pagination={{
              pageSize: 10,
              total: paginationMetaData.count,
              onChange: change,
            }}
          />
        </div>
        {userMeData.status === "NOT_UPDATED" && (
          <CompleteProfileModel
            active={active}
            setActive={setActive}
            target={userMeData.currentRole}
          />
        )}
        {/* {!loading && <RoleSwitch userRoles={userRoles} />} */}
      </div>
    </section>
  );
}
